import React, { useEffect, useRef, useState } from 'react'
import CouponTypeOptions from './CouponTypeOptions'
import { Button, Tab, Tabs, styled } from '@mui/material'
import { TabContext, TabPanel } from '@mui/lab';
import CouponConfigurableLabel from '../CouponConfigurableLabel';
import MarketDetails from './MarketDetails/MarketDetails';
// import UsabilityLimits from './usabilityLimits/UsabilityLimits';
import { DefineCouponPropsTypes, SchemePlaygroundType } from '../../types';
import { useSelector } from 'react-redux';
import { resetAllData, updateCurrentTab, updatePlaygroundMode } from '../../../../stateManagement/actions/manageCouponActions';
import ValidationPopUp from '../validationPopup/ValidationPopUp';
import ValidationContent from '../validationPopup/ValidationContent';
import { validateALLTabsData } from '../validationPopup/validationService';
import { LAST_TAB, MetaData, labelMappings } from '../../utils/utils';
import { postScheme, checkUnsavedData } from '../../services/services';
import { openPopup } from '../../../../stateManagement/actions/popupActions';
import Recurrence from './recurrence/Recurrence';
import SchemePlayground from '../schemePlayground/SchemePlayground';
import OverAndAboveBody from './overAndAboveBody/OverAndAboveBody';
import { ConfirmationPopUp } from '../../../../components/popup/confirmationPopUp';
import { useNavigate } from 'react-router-dom';
import { KeyboardReturnOutlined } from '@material-ui/icons';
import { ChannelkartNetworkPatch } from '../../../../services/networkService';
import { isAnyRecurrenceOptionPresent } from './recurrence/RecurrenceService';

const StyledTabs = styled((props: any) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '60%',
    backgroundColor: 'var(--coupon-dark-blue)'
  },
});

const StyledTab = styled((props: any) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  marginRight: '10px',
  borderRadius: '5px',
  fontSize: '17px',

  '&.Mui-selected': {
    color: 'var(--coupon-dark-blue)',
    background: 'var(--coupon-light-blue)',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
  '&.Mui-disabled': {
    cursor: 'not-allowed'
  }
}));

/**
 * this component is main parent component for defining/creating all Coupon Calculation Inputs.
 * For eg : coupontype, coupon description, coupon benefit , marketing details , reoccurence etc. 
 * @returns 
 */

function DefineCoupon(props: DefineCouponPropsTypes) {
  const { updateCurrentStep, setDateChanged } = props;
  const { currentTab } = useSelector((state: any) => state.manageCoupons?.configData);
  const [showOverAndAboveBody, setShowOverAndAboveBody] = useState<{ open: boolean, body: Record<string, any> }>({ open: false, body: {} });
  const { isSchemePlayground } = useSelector((state: any) => state?.manageCoupons?.data);
  const data: SchemePlaygroundType = useSelector((state: any) => state?.schemePlayground);
  const { couponEditType } = useSelector((state: any) => state.manageCoupons?.data);

  const tabsContentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const currentPageValidation = (): boolean => {
    const res = checkUnsavedData();

    if (res != null && res !== "") {
      openPopup("Error", res);
      return false;
    }

    return true;
  }

  const handleChange = async (event: React.SyntheticEvent, newValue: string) => {
    if (Object.keys(data.data).length !== 0) {
      updateCurrentTab(newValue);
      return;
    }
    const valid = currentPageValidation();
    if (!valid) return;
    updateCurrentTab(newValue);
  }
  
  const handleNextClick = async () => {
    const valid = currentPageValidation();
    if (!valid) return;
    if (currentTab === '2') {
      updateCurrentStep(MetaData.Coupon_Case_Number["Create Banner"]);
      console.log("2")
      return;
    }

    updateCurrentTab((Number(currentTab) + 1).toString());

  }

  useEffect(() => {
    if (tabsContentRef && tabsContentRef.current) {
      tabsContentRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [currentTab])


  return (
    <div style={{ height: '100%' }}>
      {
        showOverAndAboveBody.open ?
          <OverAndAboveBody body={showOverAndAboveBody.body} setShowOverAndAboveBody={setShowOverAndAboveBody} />
          :
          <TabContext value={currentTab}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <StyledTabs onChange={handleChange} variant="fullWidth" value={currentTab}>
                <StyledTab label={<CouponConfigurableLabel text='coupon-type-options-tab' style={{ cursor: 'pointer', color: 'inherit' }} />} value={"0"} />
                <StyledTab label={<CouponConfigurableLabel text='market-details' style={{ cursor: 'inherit', color: 'inherit' }} />} value={"1"} />
                <StyledTab label={<CouponConfigurableLabel text={labelMappings["usability-limits-tab"]} style={{ cursor: 'pointer', color: 'inherit' }} />} value={"2"} />
                {isSchemePlayground && <StyledTab label={<CouponConfigurableLabel text='scheme-playground' style={{ cursor: 'pointer', color: 'inherit' }} />} value={"3"} />}
              </StyledTabs>
              <div className="define-coupon-tab-content" style={{ padding: '5px 10px', flex: 1, overflowY: 'auto' }} ref={tabsContentRef}>
                <TabPanel className={`define-coupon-tab-content ${couponEditType === "edit" ? 'blurredStyles' : ''}`} tabIndex={0} value={'0'}><CouponTypeOptions /></TabPanel>
                <TabPanel className={`define-coupon-tab-content ${couponEditType === "edit" ? 'blurredStyles' : ''}`} tabIndex={1} value={'1'}><MarketDetails /></TabPanel>
                <TabPanel tabIndex={2} value={'2'}><Recurrence
                  setDateChanged={setDateChanged}
                /></TabPanel>
                {isSchemePlayground && <TabPanel tabIndex={3} value={'3'}><SchemePlayground /></TabPanel>}
                <div className="define-coupon-next-button-wrapper">
                  {
                    <Button variant='contained' onClick={handleNextClick}>Next</Button>
                  }
                </div>
              </div>
            </div>
          </TabContext>

      }
    </div>

  )
}

export default DefineCoupon